import React from "react";
import { Popover, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const { Paragraph } = Typography;

function InfoComponent({
  title = "Recipe",
  content = "Recipe Details",
  color,
}) {
  const { t } = useTranslation();
  return (
    <Popover
      placement="leftTop"
      title={t(title)}
      content={
        <div className="w-300 max-h-[200px] overflow-auto whitespace-normal text-sm">
          <Paragraph
            className="w-300 whitespace-pre-wrap"
            ellipsis={{ rows: 3, expandable: true, symbol: "more" }}
          >
            <i>{t(content)}</i>
          </Paragraph>
        </div>
      }
    >
      <InfoCircleOutlined className="text-xl text-blue-500 cursor-pointer p-2 hover:text-blue-600 transition transform hover:scale-110" />
    </Popover>
  );
}

export default InfoComponent;
